// StructuredSection.tsx
import React, { ReactNode } from 'react';
import structuredSectionStyles from './StructuredSections.module.scss';

const joinClassNames = (...classNames: (string | false | null | undefined)[]) =>
    classNames.filter(Boolean).join(' ');

export type StructuredSectionBackground = 'gray' | 'white';

interface StructuredSectionProps {
    background: StructuredSectionBackground;
    children: ReactNode;
    className?: string;
    innerClassName?: string;
    merged?: boolean;
}

const StructuredSection: React.FC<StructuredSectionProps> = ({
    background,
    children,
    className,
    innerClassName,
    merged,
}) => {
    const wrapperClassName = joinClassNames(
        structuredSectionStyles.group,
        background === 'gray'
            ? structuredSectionStyles.groupGray
            : structuredSectionStyles.groupWhite,
        merged ? structuredSectionStyles.groupMerged : undefined,
        className ?? undefined
    );

    const innerClassNameCombined = joinClassNames(
        structuredSectionStyles.groupInner,
        innerClassName ?? undefined
    );

    return (
        <div className={wrapperClassName}>
            <div className={innerClassNameCombined}>{children}</div>
        </div>
    );
};

export { structuredSectionStyles };

export default StructuredSection;
